import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { CmsTaxonomy, CmsTaxonomyGeneral } from '@fcom/core-api';

/** Labels that should always be ignored when rendering chips */
export enum IgnoreChips {
  DESTINATIONS = 'destinations',
  WORLD_OF_FINNAIR = 'worldOfFinnair',
}

export interface ChipInformation {
  label: string;
  text: string;
}

@Injectable()
export class BluewingsChipsService {
  filter$ = new BehaviorSubject(null);

  renderChips(tags: CmsTaxonomy[]): boolean {
    return tags.includes(CmsTaxonomyGeneral.BLUEWINGS_CHIPS);
  }

  filterValue(value: string): void {
    this.filter$.next(value);
  }

  teaserVisibility(tags: CmsTaxonomy[]): boolean {
    return this.filter$.value ? tags.includes(this.filter$.value) : true;
  }
}
